import app from '../../angular_app.es6';

app.directive('imageInPopup', [ () => {
  return {
    restrict: 'A',
    scope: {
      imageUrl: '@imageInPopup',
      title: '@popupTitle',
      description: '@popupDescription',
      imageHeight: '@imageHeight',
      modificator: '@modificator',
      placement: '@'
    },
    link: ($scope, $element) => {
      const klassForTitle = $scope.title && !$scope.description ? 'popup-title -no-description' : 'popup-title';
      const popupTitleKlass = $scope.title ? '' : ' -no-title';
      const imgHeight = $scope.imageHeight || 'auto';
      const classModificator = $scope.modificator || '';
      const imageClass = imgHeight === "auto" ? "-with-max-height-250" : "";

      if ($scope.imageUrl) {
        const createTitle = () => (
          `${($scope.title ? `<div class="${klassForTitle}">${$scope.title}</div>` : '') +
          ($scope.description ? `<div class="popup-description${popupTitleKlass}">${$scope.description}</div>` : '')
          }<div class="popup-image">` +
          `<img class="${imageClass}" src="${$scope.imageUrl}" alt="${$scope.description}" height="${imgHeight}" />` +
          `</div>`
        );

        $element.tooltip({
          placement: $scope.placement || 'auto right',
          title: createTitle(),
          html: true,
          container: 'body',
          viewport: { selector: 'body', padding: 0 },
          template:
          `<div class="tooltip -express-tooltip-preview ${classModificator}" role="tooltip">` +
            `<div class="tooltip-arrow"></div>` +
            `<div class="tooltip-inner">` +
            `</div>` +
          `</div>`
        });

        const watcherFunction = $scope.$watch(
          () => (`${$scope.title}${$scope.imageUrl}`),
          (newTitle) => {
            if (newTitle) {
              $element.attr('data-original-title', createTitle()).tooltip('fixTitle');
            }
          }
        );

        $scope.$on(
          "$destroy", () => {watcherFunction && watcherFunction();}
        );
      }
    }
  };
} ]);
